import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			Miopaj infanoj, presbiopaj maljunuloj… 
			Ĝenerale dirite, la afero kompreneblas.
		</p>

		<p class="mb-3">
			Infano alproksimigas la mondon por pli bone ĝin vidi; maljunulo formovas ĝin: kion li ankoraŭ ne vidis tie!
		</p>
	`
	)
}

const itemName = {
	esp: 'Diversaj vidmanieroj'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;